<div #mapWrapper class="mapWrapper">
    <ng-select placeholder="digitare l'indirizzo da cercare" ngxAppDelayedInput *ngIf="viewIndirizzo"
        (delayedInput)="searchEvent($event.target.value)" (change)="onChange()" name="indirizzoSelezionato"
        [(ngModel)]="indirizzoSelezionato" (clear)="clearAddress()">
        <ng-option nbSpinner="true" *ngIf="loading" nbSpinnerSize="tiny" nbSpinnerStatus="primary"></ng-option>
        <ng-option *ngFor="let s of searchResults" [value]="s">{{s.display_name}}</ng-option>
    </ng-select>
    <div id="map" leaflet #map [leafletOptions]="MapOptions" (leafletMapReady)="initializeMap($event)"></div>
</div>